import React from 'react';
import {
  Button as RebassButton,
  ButtonProps as RebassButtonProps,
} from 'rebass';
import Icon, { IconType } from '../Icon/Icon';
import { isMobile, isTablet } from 'react-device-detect';

type buttonVariants =
  | 'primary'
  | 'secondary'
  | 'danger'
  | 'outline'
  | 'success'; // keyOf from  button variants

export type ButtonProps = Omit<RebassButtonProps, 'css'> & {
  /**
   * Style of button
   */
  variant?: buttonVariants;
  /**
   * Icon to be included
   */
  icon?: IconType;
  /**
   * Optional click handler
   */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const Button = (props: ButtonProps): JSX.Element => {
  const { icon, children, title, variant = 'primary' } = props;
  const renderChildren = !!children && (!icon || !isMobile || isTablet);

  if (props.onClick && props.type !== 'submit') {
    const oldProps = props;
    props = {
      ...oldProps,
      onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        oldProps.onClick?.(e);
      },
    };
  }

  return (
    <RebassButton
      {...props}
      variant={variant}
      sx={{
        display: 'inline-flex',
        '&:hover': {
          cursor: 'pointer',
        },
        '& > svg': {
          mr: renderChildren ? 1 : undefined,
        },
        ...props.sx,
      }}
      pr={renderChildren ? undefined : [2, 2, 2]}
      pl={renderChildren ? undefined : [2, 2, 2]}
      title={
        title ||
        (!renderChildren && typeof children === 'string' ? children : undefined)
      }
    >
      {icon && <Icon pointerEvents="none" icon={icon} />}
      {renderChildren ? children : undefined}
    </RebassButton>
  );
};

export default Button;
